import { useEffect, useState } from 'react'
import { WebOCRSDK } from '../../sdks/WebOCRSDK'

import axios from 'axios'

import RGIcon from '../../assets/images/rg-icon.png'
import CNHIcon from '../../assets/images/cnh-icon.png'
import CNHDigitalIcon from '../../assets/images/cnh-digital-icon.png'
import RNEIcon from '../../assets/images/rne-icon.png'
import PassportIcon from '../../assets/images/passport-icon.png'
import CTPSIcon from '../../assets/images/ctps-icon.png'
import OthersIcon from '../../assets/images/others-icon.png'
import CINIcon from '../../assets/images/cin-digital.svg'
import MilitaryRegistryIcon from '../../assets/images/military-registry-icon.svg'

import { Box } from '@mui/material'
import { Logo } from '../../components';
import { ErrorPage } from "../ErrorPage"
import { LoadingPage } from '../LoadingPage'
import { Footer } from "../../components/Footer"
import { Wallpaper } from '../../components/Wallpaper'
import { PersonalDocumentConfirmationBatch } from './personalDocumentConfirmationBatch'
import { CollectImageTitle, DocumentIcon, DocumentText} from './styles'
import { setDatadogError } from 'src/services/datadog'

export const PersonalDocumentBatch = (props) => {

    const { clientThemeSettings, signBatchData, setSignerBatchStep, setSignBatchData, signerBatchHash } = props
    const initialError = {"has_error": false, "status": 0}

    const [error, setError] = useState(false)
    const [loading, setLoading] = useState(true)
    const [hasMadeRequest, setHasMadeRequest] = useState(false)
    const [ocrActive, setOcrActive] = useState(false)

    const documentTemplates = {
        'rg': {
            'icon': RGIcon,
            'title': 'Cédula de Identidade (RG/CIN)'
        },
        'cnh': {
            'icon': CNHIcon,
            'title': 'Carteira de Habilitação (CNH)'
        },
        'cnh_digital': {
            'icon': CNHDigitalIcon,
            'title': 'Carteira de Habilitação Digital (CNH)'
        },
        'rg_cin_digital': {
            'icon': CINIcon,
            'title': 'Cédula de Identidade Digital (RG/CIN)'
        },
        'cin_digital': {
            'icon': CINIcon,
            'title': 'Carteira de Identidade Nacional (CIN)'
        },
        'passport': {
            'icon': PassportIcon,
            'title': 'Passaporte'
        },
        'rne': {
            'icon': RNEIcon,
            'title': 'Registro Nacional de Estrangeiros (RNE)'
        },
        'ctps': {
            'icon': CTPSIcon,
            'title': 'Carteira de Trabalho e Previdência Social (CTPS)'
        },
        'military_registry': {
            'icon': MilitaryRegistryIcon,
            'title': 'Cartão Militar de Identificação'
        },
        'others': {
            'icon': OthersIcon,
            'title': 'Outros Documentos'
        }
    }

    const defaultClientDocumentTemplates = [
        'rg',
        'cnh'
    ]

    const clientDocumentTemplates = signBatchData.document_templates ?? defaultClientDocumentTemplates;

    
    useEffect(() => {
        setLoading(false)
    }, [])

    if (loading) {
        return (
            <LoadingPage clientThemeSettings={clientThemeSettings} />
        )
    }

    const submitOCRKeys = (ocrKeys) => {

        if (hasMadeRequest) {
            return  
        }

        let payload
        if(ocrKeys.length === 1){
            const ocrKey = ocrKeys[0]['ocr_key']

            payload = {
                "ocr_full_document_key": ocrKey
            }
        }
        else if (ocrKeys.length === 2){
            const firstOcrKey  = ocrKeys[0]
            const secondOcrKey = ocrKeys[1]

            const firstDocumentArray = firstOcrKey['template'].split('_')
            const ocrFrontKey = firstDocumentArray[firstDocumentArray.length - 1]  === 'front' ? firstOcrKey['ocr_key'] : secondOcrKey['ocr_key']
            const ocrBackKey  = firstDocumentArray[firstDocumentArray.length - 1]  === 'back' ? firstOcrKey['ocr_key'] : secondOcrKey['ocr_key']

            payload = {
                "ocr_front_key": ocrFrontKey,
                "ocr_back_key": ocrBackKey
            }
        }
        else {
            setDatadogError("Unspported ocr key amount", {
                    "ocr_key_amount": ocrKeys.length,
                    "signData": signBatchData
                })
        }
        
        const config = {
            headers:
            {
                'Authorization': signBatchData.signer_token
            }
        }
        
        payload = { 
            ...payload, 
            "step": "personal_document",
            "event_date": new Date().toISOString()
        }

    
        setLoading(true)
        setHasMadeRequest(true)

        axios.patch('/signer_batch', payload, config)
        .then(response => {
            setSignerBatchStep(response.data.next_step)
            setSignBatchData({ ...signBatchData, ...response.data })
        })
        .catch((error) => {
            if ([401, 403, 409].includes(error.response?.status)) {
                setError({
                    "has_error": true,
                    "status": error.response.status
                })
            } else {
                setError({
                    "has_error": true,
                    "status": 500
                })
            }

            setHasMadeRequest(false)
        })
        .finally(() => {
            setLoading(false)
        })
    }

    return (
        <Wallpaper backgroundColor={clientThemeSettings["background_color"]} style={{ padding: '10px' }}>
            <div className="base-container base-container-width base-container-padding" style={{ backgroundColor: "rgb(245, 245, 242)" }}>
                <Logo imageSource={clientThemeSettings.logo_url} />
                <Box>
                    {(!signBatchData.collect_personal_document) && signBatchData.personal_documents ? (
                        <PersonalDocumentConfirmationBatch clientThemeSettings={clientThemeSettings} signBatchData={signBatchData} setSignerBatchStep={setSignerBatchStep} />
                    ) : (
                        <div>
                            <CollectImageTitle>
                                Agora vamos coletar imagens do seu documento. Escolha entre os tipos abaixo:
                            </CollectImageTitle>
                            {clientDocumentTemplates && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '20px', marginBottom: '20px' }}>

                                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-evenly', width: '100%' }}>
                                    {clientDocumentTemplates.map((type, index) => (

                                        <button
                                            key={index}
                                            onClick={() => setOcrActive(true)}
                                            style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '10px 15px',
                                            border: '1px solid #ccc',
                                            borderRadius: '5px',
                                            backgroundColor: '#f9f9f9',
                                            outline: 'none',
                                            WebkitTapHighlightColor: 'transparent'
                                            }}
                                            type='primary'
                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#e9e9e9'}
                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#f9f9f9'}
                                            >
                                            <DocumentIcon
                                            src={documentTemplates[type]['icon']}
                                            alt={type}
                                            />
                                            <DocumentText>{documentTemplates[type]['title']}</DocumentText>
                                        </button>
                                    ))}
                                </div>

                                </div>}
                        </div>
                    )}
                </Box>
                <Footer />
            </div>
            {error.has_error &&
                <ErrorPage
                    error={error}
                    redirectToLogin={() => setSignerBatchStep("login")}
                    resetError={() => setError(initialError)}
                    clientThemeSettings={clientThemeSettings}
                />
            }
            {ocrActive && <WebOCRSDK ocrToken={signBatchData.ocr_token} sessionId={signerBatchHash} clientThemeSettings={clientThemeSettings} documentTypes={clientDocumentTemplates} documentNumber={signBatchData.signer_data?.document_number} imageKey={signBatchData.image_key} onSuccess={(result) => { setOcrActive(false); submitOCRKeys(result); }} onError={() => setOcrActive(false)} />}
        </Wallpaper>
    )
}